import React, { useEffect, useState } from "react";
import { Card, message, Form, Layout, Button, Typography } from "antd";
import axios from "axios";
import UserForm from "../../../Components/Form/UserForm";
import Sidebar from "../../../Components/Sidebar";
import { BASE_URL } from "../../../Config";
import { MenuOutlined } from "@ant-design/icons";

const { Header } = Layout;
const { Text } = Typography;

const AddUserPage = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");

      await axios.post(`${BASE_URL}/users`, values, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      message.success("User added successfully");
      form.resetFields();
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to add user");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />
      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header
          className="MainHeader"
        >
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div className="AddNewUserTitle" style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>Add User</Text>
          </div>
        </Header>
        <Card title="Add User" className="AddUserCard">
          <UserForm form={form} onFinish={onFinish} loading={loading} />
        </Card>
      </Layout>
    </Layout>
  );
};

export default AddUserPage;
